import { render, staticRenderFns } from "./ColoredButtonInverted.vue?vue&type=template&id=3164343e&scoped=true"
import script from "./ColoredButtonInverted.vue?vue&type=script&lang=js"
export * from "./ColoredButtonInverted.vue?vue&type=script&lang=js"
import style0 from "./ColoredButtonInverted.vue?vue&type=style&index=0&id=3164343e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164343e",
  null
  
)

export default component.exports